import { IRow } from "../types";

export const form11HeaderCells = [
    "№ п/п",
    `
    Наименование основного показателя, единица измерения
    `,
    "Значение показателя в 2024 году",
    "Значение показателя 2025 года*",
    `
    Документы, подтверждающие значение показателя (при необходимости предъявляются по
    дополнительному запросу)
    `,
    "Загруженные файлы(ссылки)",
];

export const form11Rows: IRow[] = [
    {
        col1: "1",
        col2: "Количество разработанных образовательных модулей в отчетном году, единиц",
        col3: { name: "info.f11.n1.0" },
        col4: { name: "info.f11.n1.1" },
        col5: "Копии локальных актов ВУЗа, подтверждающих количество разработанных образовательных модулей в отчетном году, РПД",
        col6: { name: "info.f11.n1.2", fileList: true },
    },
    {
        col1: "2",
        col2: "Количество разработанных мастер-классов в отчетном году, единиц",
        col3: { name: "info.f11.n2.0" },
        col4: { name: "info.f11.n2.1" },
        col5: "Копии локальных актов ВУЗа, подтверждающих количество разработанных мастер-классов в отчетном году",
        col6: { name: "info.f11.n2.2", fileList: true },
    },
    {
        col1: "3",
        col2: "Количество разработанных курсов повышения квалификации в отчетном году, единиц",
        col3: { name: "info.f11.n3.0" },
        col4: { name: "info.f11.n3.1" },
        col5: "Копии локальных актов ВУЗа, подтверждающих количество разработанных курсов повышения квалификации в отчетном году, программы повышения квалификации",
        col6: { name: "info.f11.n3.2", fileList: true },
    },
    {
        col1: "4",
        col2: "Количество разработанных курсов профессиональной переподготовки кадров в отчетном году, единиц",
        col3: { name: "info.f11.n4.0" },
        col4: { name: "info.f11.n4.1" },
        col5: "Копии локальных актов ВУЗа, подтверждающих количество разработанных курсов профессиональной переподготовки кадров в отчетном году, программы профессиональной переподготовки",
        col6: { name: "info.f11.n4.2", fileList: true },
    },
];
